import { jsx, Fragment } from "@emotion/react/jsx-runtime";
import { Text } from "@datacamp/waffles/text";
import { useTranslation } from "react-i18next";
const ContentDuration = (props) => {
  const {
    timeNeededInHours
  } = props;
  const {
    t
  } = useTranslation();
  if (!timeNeededInHours) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const formattedTime = `${timeNeededInHours.toLocaleString()} ${t("common:hour", {
    count: timeNeededInHours
  })}`;
  return /* @__PURE__ */ jsx(Text, { children: formattedTime });
};
export {
  ContentDuration
};
